module.exports = __webpack_public_path__ + "static/media/meter-moderately-conservative.5dac36ee.svg";